import { Component, OnInit, AfterContentInit, ElementRef, OnDestroy, HostListener } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as config from '../../../../common-components/config/user-data.config';
import * as UserDataConfig from '../../config/user-data.config';
import { Router, ActivatedRoute } from '@angular/router';
import { FormValidationsService, QuoteDataCaptureService, ModalScroll, SERVICE_END_POINT, AnalyticsService, AuthService } from 'src/app/shared';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../store/state/app.state';
import { BeforeStart } from '../../../../model/ngrx/before-start.model';
import * as BeforeStartActions from '../../../../store/actions/before-start.actions';
import { Observable, Subscription, Subject } from 'rxjs';
import { ButtonComponent } from 'src/app/form-elements';
import * as PersDetailsActions from '../../../../store/actions/personal-details.actions';
import { UtilService } from '../../../../shared';
import { LocationStrategy } from '@angular/common';
import { RefNo } from 'src/app/model/ngrx/reference-number.model';
import { STORE_VAL } from 'src/app/shared/constants/store-val.constant';
import { PersonalDetails } from '../../../../model/ngrx/personal-details.model';
import { AlertModal } from 'src/app/model/alert';
import { DeviceDimensionsService } from 'src/app/shared/utilities/functionality/device-dimensions.service';

@Component({
  selector: 'app-questionary',
  templateUrl: './questionary.component.html',
  styleUrls: ['./questionary.component.scss']
})
export class QuestionaryComponent implements OnInit, OnDestroy {
  userForm: UntypedFormGroup;
  questionForm: UntypedFormGroup;
  contentData;
  tooltipModal;
  public CMSData;
  screenName;
  deviceType: any;
  public userInputDetail = UserDataConfig.ElementsConfig;
  public channelConfig = config;
  beforeStartStore: Observable<BeforeStart[]>;
  questionaryForm: BeforeStart;
  visibilityConstant = {
    enableRetirement: null,
    enablePension: null,
    enableFinance: null,

  };
  public tooltipModalConfig: AlertModal;
  public noPackValidatorFlag: boolean;
  public nextButtonDisabled: boolean;
  public noSelectedFlag: boolean;
  public dontShowMsgAgain: boolean;
  public noWarningMSg: boolean;
  // protected packAlertModalConfig: AlertModal = new AlertModal('alert', "A message you should pay attention to", '', 'OK', '', '');
  public packAlertModalConfig: AlertModal;
  private subscriptn: Subscription;
  private subscripBeforeLogin: Subscription;
  private subscripSaveProgress: Subscription;
  private subscripLogout: Subscription;
  // public letterPackQuestionConfig = {};
  loginDetails;
  referenceNumberStore: Observable<RefNo[]>;
  referenceNumber: RefNo;
  personDetail: PersonalDetails;
  displayTooltipAlert: boolean = false;
  personalDetailsStore: Observable<PersonalDetails[]>;
  constructor(private fb: UntypedFormBuilder, private router: Router,
              private activatedRoute: ActivatedRoute, private store: Store<AppState>,
              private quoteDatacaptureService: QuoteDataCaptureService,
              private btnFocusOnModalClose: ModalScroll, public el: ElementRef,
              private utilService: UtilService, private analyticsService:AnalyticsService,
              private locationStrategy: LocationStrategy, private authService: AuthService,
              private deviceDimensionsService: DeviceDimensionsService) {
    this.contentData = this.activatedRoute.snapshot.data.contentData.beforeYouStart;
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    this.beforeStartStore = store.select(STORE_VAL.before_start);
    // console.log('personal-store', this.personalDetailsStore);
    this.beforeStartStore.subscribe((val) => {
      if (val.length > 0) {
        // this.questionForm.controls['retirementOptions'].setValue('Y');
        this.questionaryForm = val[0];
      }
    });
    this.personalDetailsStore = store.select(STORE_VAL.personal_details);
    this.personalDetailsStore.subscribe((val) => {
      if (val.length > 0) {
        this.personDetail = val[0];
      }
    });
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        this.loginDetails = res[0];
      }
    });
    this.referenceNumberStore = store.select(STORE_VAL.ref_no);
    this.referenceNumberStore.subscribe((val) => {
      if (val.length > 0) {
        this.referenceNumber = val[0];
      } else {
        this.referenceNumber = null;
      }
    });
    /*
    this.locationStrategy.onPopState((data ) => {
      // set isBackButtonClicked to true.
     // this.someNavigationService.setBackClicked(true);
      //console.log(data);
      // window.onunload = () => null;
      //history.pushState(null, null, router.url);
      history.pushState(null, null, location.href);
      window.onpopstate = () => history.go(1);
      // return false;
    });
    */
  }
  disablzedback() { history.go(1); }
  ngOnInit() {
    this.detectScreenSize();
    this.tooltipModalConfig = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
    // this.approxQuotationTime = this.activatedRoute.snapshot.data.contentData.contentBottomNavigationBar.approxQuotationTime;
    this.analyticsService.eventTrack({ referenceId: this.getRefNo() });
    this.GetCMSDataService();
    /** This line gets the loads the CMSData to the contentData */
    this.packAlertModalConfig = this.contentData.modalConfigletterPackQuestion;
    if (this.questionaryForm) {
      this.questionForm = this.fb.group({
        letterPack: [this.questionaryForm.letterPack, Validators.required],
        retirementOptions: [this.questionaryForm.retirementOptions, Validators.required],
        // pensionGuidance: [this.questionaryForm.pensionGuidance, Validators.required],
        // financialAdvise: [this.questionaryForm.financialAdvise, Validators.required]
      });

    } else {
      this.setQuestionForm();
    }
    this.store.select(STORE_VAL.loggedin_detail).subscribe(res => {
      if (res.length > 0) {
        let customerCareData = this.getCustomerCareInfo(res[0]);
        this.store.dispatch(new PersDetailsActions.RemovePersonalDetails(0));
        // tslint:disable-next-line: max-line-length
        this.store.dispatch(new PersDetailsActions.AddPersonalDetails(
          // tslint:disable-next-line: max-line-length
          {
            // tslint:disable-next-line:max-line-length
            contactNumber: res[0]['customer'].contactNumber, 
            dateOfBirth: res[0]['customer'].dateOfBirth, 
            emailAddress: res[0]['customer'].emailAddress, 
            forename: res[0]['customer'].forename,
            // tslint:disable-next-line: max-line-length
            gender: res[0]['customer'].gender, maritalStatus: res[0]['customer'].maritalStatus,
            // tslint:disable-next-line: max-line-length
            postcode: res[0]['customer']['address'].postcode, surname: res[0]['customer'].surname, ukaddressIndicator: res[0]['customer'].ukaddressIndicator,
            consentDate: res[0]['customer'].consentDate, consentIndicator: res[0]['customer'].consentIndicator,
            pwAppointmentdate: res[0]['customer'].pwAppointmentdate,
            customerCareInfo: customerCareData,
            internalSoftOptInInd: this.personDetail['internalSoftOptInInd'],
            homePhone:res[0]['customer'].homePhone,
            mobilePhone:res[0]['customer'].mobilePhone,


          }));
        // this.setLetterpackQuestion(res[0]['customer']);
      }
    });
    this.userFormData();
    // tslint:disable-next-line:max-line-length
    this.subscripBeforeLogin = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLoginFunction.subscribe(() => {
      this.saveAfterLogin();
    });
    this.subscripSaveProgress = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeSaveFunction.subscribe(() => {
      this.saveProgress();
    });
    this.subscripLogout = this.quoteDatacaptureService.subsVar = this.quoteDatacaptureService.invokeLogoutFunction.subscribe(() => {
      this.saveAfterLogout();

    });
  }

  @HostListener('window:resize', [])
  public onResize() {
    this.detectScreenSize();
  }
  private detectScreenSize() {
    this.deviceType=this.deviceDimensionsService.onResize('$event');
  }

  displayTooltipMessage(){
    let config = this.contentData.letterPackQuestion.infoIconData;
    this.tooltipModal.content = config.content.replace('<a', '<a class="moneyhelperTxt"');
    this.displayTooltipAlert = true;
  }

  alertTooltipPrimaryBtnClick() {
    this.displayTooltipAlert = false;
  }
  closeModal() {
    this.displayTooltipAlert = false;
  }

  getCustomerCareInfo(loginDetails: any) {
    return (this.personDetail && !this.quoteDatacaptureService.checkIfObjEmpty(this.personDetail['customerCareInfo'])
      ? this.personDetail['customerCareInfo'] : (loginDetails && loginDetails['customer'] && !this.quoteDatacaptureService.checkIfObjEmpty(loginDetails['customer']['customerCareInfo'])
        ? loginDetails['customer']['customerCareInfo'] : null));
  }
  setLetterpackQuestion = (customerObj) => {
    if (this.questionForm && !this.questionForm.controls.letterPack.value
      && customerObj && customerObj.surname && customerObj.title) {
      this.questionForm.controls['letterPack'].setValue('Y');
    }
  }
  ngOnDestroy() {
    if (this.subscriptn) {
      this.subscriptn.unsubscribe();
    }
    if (this.subscripBeforeLogin) {
      this.subscripBeforeLogin.unsubscribe();
    }
    if (this.subscripSaveProgress) {
      this.subscripSaveProgress.unsubscribe();
    }
    if (this.subscripLogout) {
      this.subscripLogout.unsubscribe();
    }
  }

  userFormData = () => {
    if(this.CMSData) {
      this.userInputDetail.buttonConfig.label = this.CMSData.commonBlock.string_NextCTALabel; // 'Next'; // this.CMSData.commonBlock.string_NextCTALabel
    }
    // //console.log('1 => ', this.userInputDetail['buttonConfig']);
    // //console.log('2 => ', this.userInputDetail);
    this.userForm = this.fb.group({
      next: ['']
    });
  }

  setQuestionForm() {
    this.questionForm = this.fb.group({
      letterPack: [null, Validators.required],
      retirementOptions: [null, Validators.required],
      // pensionGuidance: ['', Validators.required],
      // financialAdvise: ['', Validators.required]
    });
  }
  saveFormValues() {
    this.store.dispatch(new BeforeStartActions.RemoveBeforeStart(0));
    this.store.dispatch(new BeforeStartActions.AddBeforeStart({
      letterPack: this.questionForm.controls.letterPack.value ? this.questionForm.controls.letterPack.value : null,
      retirementOptions: this.questionForm.controls.retirementOptions.value ? this.questionForm.controls.retirementOptions.value : null,
      // pensionGuidance: this.questionForm.controls.pensionGuidance.value ? this.questionForm.controls.pensionGuidance.value : null,
      // financialAdvise: this.questionForm.controls.financialAdvise.value ? this.questionForm.controls.financialAdvise.value : null,
      riskAndStaticQuestion: this.createQuestionarray(),
    }));
  }
  saveProgress() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe();
  }
  saveAfterLogin() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res =>
      this.utilService.afterSaveSuccesfully());
  }
  saveAfterLogout() {
    this.saveFormValues();
    this.subscriptn = this.quoteDatacaptureService.postQuoteDataCapture(false).subscribe(res => {
      this.authService.logout();
    });
  }
  createQuestionarray(): any {
    const questionArray = [];
    if (this.questionForm.controls.letterPack.value) {
      questionArray.push({
        questionCode: 'letterPackQuestion',
        // question: this.contentData.letterPackQuestion.questionStatement,
        questionType: this.contentData.letterPackQuestion.questionType,
        answer: this.questionForm.controls.letterPack.value
      });
    }
    if (this.questionForm.controls.retirementOptions.value) {
      questionArray.push({
        questionCode: 'retirementOptionsQuestion',
        // question: this.contentData.retirementOptionsQuestion.questionStatement,
        questionType: this.contentData.retirementOptionsQuestion.questionType,
        answer: this.questionForm.controls.retirementOptions.value
      });
    }
    // if (this.questionForm.controls.pensionGuidance.value) {
    //   questionArray.push({
    //     questionCode: 'pensionGuidanceQuestion',
    //     // question: this.contentData.pensionGuidanceQuestion.questionStatement,
    //     questionType: this.contentData.pensionGuidanceQuestion.questionType,
    //     answer: this.questionForm.controls.pensionGuidance.value
    //   });
    // }
    // if (this.questionForm.controls.financialAdvise.value) {
    //   questionArray.push({
    //     questionCode: 'financialAdviseQuestion',
    //     // question: this.contentData.financialAdviserQuestion.questionStatement,
    //     questionType: this.contentData.financialAdviserQuestion.questionType,
    //     answer: this.questionForm.controls.financialAdvise.value
    //   });
    // }

    return questionArray;
  }
  gotoPersonalDetails = () => {
    if (this.questionForm.valid && !this.noSelectedFlag) {
      this.store.dispatch(new BeforeStartActions.RemoveBeforeStart(0));
      this.store.dispatch(new BeforeStartActions.AddBeforeStart({
        letterPack: this.questionForm.controls.letterPack.value ? this.questionForm.controls.letterPack.value : null,
        retirementOptions: this.questionForm.controls.retirementOptions.value ? this.questionForm.controls.retirementOptions.value : null,
        // pensionGuidance: this.questionForm.controls.pensionGuidance.value ? this.questionForm.controls.pensionGuidance.value : null,
        // financialAdvise: this.questionForm.controls.financialAdvise.value ? this.questionForm.controls.financialAdvise.value : null,
        riskAndStaticQuestion: this.createQuestionarray(),
      }));
      this.btnFocusOnModalClose.handleModalScrollFlag({ scrollModalFlag: false, btnFocus: false });
      this.quoteDatacaptureService.postQuoteDataCapture(true).subscribe(res => {
        //console.log(res);
        // this.router.navigate(['/home/your-personal-details']);
        this.router.navigate(['/home/your-pension-savings']);

      });
    } else {
      FormValidationsService.validateAllFormFields(this.questionForm, this.analyticsService);
      // this.noPackValidatorFlag = true;
      setTimeout(() => {
        this.scrollInvalidForm();
      });
    }

  }
  scrollInvalidForm() {
    const invalidElements = this.el.nativeElement.querySelectorAll('.form-validation-error');
    if (invalidElements.length > 0) {
      invalidElements[0].scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    }
  }

  getToggleValue(toggleVal) {
    this.noPackValidatorFlag = (toggleVal === 'N' ? true : false);
    this.noSelectedFlag = (toggleVal === 'N' ? true : false);
    this.nextButtonDisabled = (this.noSelectedFlag === true ? true : false);
    if(this.noPackValidatorFlag === true && !this.noWarningMSg) {
      this.analyticsService.eventTrack({ type: 'Lightbox', name: 'You must have received your letter or pack', pageID: this.getCurrentScreenURL() });
    }
  }

  alertNoPackPrimaryBtnClick() {
    this.closeNoPackModal();
  }
  // alertNoPackSecondaryBtnClick() {
  //   this.closeNoPackModal();
  // }
  closeNoPackModal() {
    this.noPackValidatorFlag = false;
    this.noWarningMSg = (this.dontShowMsgAgain === true ? true : false);
  }
  dontShowUPMsgAgain(val) {
    this.dontShowMsgAgain = val;
  }


/** Code block for CMS */
GetCMSDataService() {
  const URL =  SERVICE_END_POINT.higherEnvironment.CMS_BeforeYouStart;
  //console.log('original value = ', this.contentData.letterPackQuestion.infoIconData.content);
  this.utilService.getCMSData(URL)
  .subscribe(res => {
    //console.log('2 GetCMSDataService => ', res);
    this.CMSData = res;
    if(this.CMSData) {
    /** In the line below we are over-writing the contentData object values with CMSData object values */
      this.contentData.letterPackQuestion.questionStatement = this.CMSData.string_SchemeProviderPackQuestionWording;
      // tslint:disable-next-line:max-line-length
      this.contentData.letterPackQuestion.infoIconData.content = this.CMSData.html_SchemeProviderPackInformationWording.replace('<a', '<a class="anchor-padding"');

      this.contentData.retirementOptionsQuestion.questionOptions.find(q => q['label'] === 'No').infoText
      = this.CMSData.string_RetirementOptionsRiskQuestionNoWarningMessage;
      this.contentData.retirementOptionsQuestion.questionStatement = this.CMSData.string_RetirementOptionsRiskQuestion;

      this.contentData.modalConfigletterPackQuestion.content = this.CMSData.string_PackNotReceivedErrorMessageText;
      this.contentData.modalConfigletterPackQuestion.header = this.CMSData.string_PackNotReceivedErrorMessageTitle;
      this.contentData.modalConfigletterPackQuestion.footerPrimaryBtnLabel = this.CMSData.commonBlock.string_OKCTALabel;

      // this.contentData.pensionGuidanceQuestion.questionStatement = this.CMSData.string_PensionWiseRiskQuestion;
      // this.contentData.pensionGuidanceQuestion.infoIconData.content = this.CMSData.string_PensionsWiseInformationWording
       + this.CMSData.html_PensionWiseLink.replace('<a', '<a class="anchor-padding"');

      // this.contentData.financialAdviserQuestion.questionStatement = this.CMSData.string_FinancialAdviserRiskQuestion;
      // this.contentData.financialAdviserQuestion.questionOptions.find(res => res['label'] === 'No').infoText
      // = this.CMSData.html_FinancialAdviserRiskQuestionWarningMessage.replace('<a', '<a class="anchor-padding"');
      // this.contentData.financialAdviserQuestion.questionOptions.find(res => res['label'] === 'Unsure').infoText
      // = this.CMSData.html_FinancialAdviserRiskQuestionWarningMessage.replace('<a', '<a class="anchor-padding"');
     // = this.CMSData.string_FinancialAdviserRiskQuestionWarningMestring_PackNotReceivedErrorMessageTextssage + ' ' + this.CMSData.html_MoneyAdviseServiceDirectoryLink;
      // this.CMSData.string_MoneyAdviseServiceDirectoryLinkText;
      // <a href=\"//www.moneyadviceservice.org.uk/directory\" target=\"_blank\">www.moneyadviceservice.org.uk/directory</a>.
      // this.contentData.letterPackQuestion.infoIconData.content = this.CMSData.stringGroup_SchemeProviderPackInformationWording;
      
      // this.contentData.pensionGuidanceQuestion.questionOptions.find(q => q['label'] === 'No').infoText
      // = this.CMSData.string_PensionWiseRiskQuestionWarningMessage
        // + this.CMSData.html_PensionWiseLink.replace('<a', '<a class="anchor-padding"');
      // this.contentData.pensionGuidanceQuestion.questionOptions.find(q => q['label'] === 'Unsure').infoText
      // = this.CMSData.string_PensionWiseRiskQuestionWarningMessage
      // + this.CMSData.html_PensionWiseLink.replace('<a', '<a class="anchor-padding"');

      this.contentData.retirementOptionsQuestion.validationMsg = this.CMSData.commonBlock.string_SelectRiskQuestionErrorMessage;
      this.contentData.letterPackQuestion.validationMsg = this.CMSData.commonBlock.string_SelectRiskQuestionErrorMessage;
      // this.contentData.pensionGuidanceQuestion.validationMsg = this.CMSData.commonBlock.string_SelectRiskQuestionErrorMessage;
      // this.contentData.financialAdviserQuestion.validationMsg = this.CMSData.commonBlock.string_SelectRiskQuestionErrorMessage;
      this.userInputDetail['buttonConfig'].label = this.CMSData.commonBlock.string_NextCTALabel;

      //console.log('changed value = ', this.contentData.retirementOptionsQuestion.questionOptions.infoText);
      }
  });
}

/** End of code block for CMS */
 /** Web analytics block */

/** For web tracking */
getCurrentScreenURL() {
this.screenName = this.utilService.getScreenNameFromURL(this.router.url);
return this.screenName;
}
getRefNo() {
  return  this.referenceNumber ? this.referenceNumber : null;
}

OnBackClick() {
  this.store.dispatch(new BeforeStartActions.RemoveBeforeStart(0));
  this.store.dispatch(new BeforeStartActions.AddBeforeStart({
    letterPack: this.questionForm.controls.letterPack.value ? this.questionForm.controls.letterPack.value : null,
    retirementOptions: this.questionForm.controls.retirementOptions.value ? this.questionForm.controls.retirementOptions.value : null,
    // pensionGuidance: this.questionForm.controls.pensionGuidance.value ? this.questionForm.controls.pensionGuidance.value : null,
    // financialAdvise: this.questionForm.controls.financialAdvise.value ? this.questionForm.controls.financialAdvise.value : null,
    riskAndStaticQuestion: this.createQuestionarray(),
  }));
  this.router.navigateByUrl('home/guidance-and-advice')
}
}
